const state = {
  titles: [],
  terms: [],
  frequencies: [{
      label: "Monthly",
      value: 1
    },
    {
      label: "One Time Payment",
      value: 0.083333333
    } //not enough time to fix this correctly
  ],
  licenseTypes: [
    { label: "Open License", value: 1 },
    { label: "Provisional 2", value: 2 },
    { label: "Provisional 1", value: 3 },
    { label: "Learner", value: 4 },
    { label: "Unlicenced", value: 5 }
  ]
};

const getters = {
  getTitles: state => state.titles,
  getTerms: state => state.terms,
  getFrequencies: state => state.frequencies,
  getLicenseTypes: state => state.licenseTypes
};

const mutations = {
  setTitles(state, titles) {
    state.titles = titles;
  },
  setTerms(state, terms) {
    state.terms = terms;
  }
};

const actions = {
  saveTitles(context, isDispatched = false) {
    context.commit("setTitles", [{
        label: "Mr",
        value: 1
      },
      {
        label: "Ms",
        value: 2
      },
      {
        label: "Mrs",
        value: 3
      },
      {
        label: "Miss",
        value: 4
      },
      {
        label: "Mx",
        value: 5
      }
    ]);
  },
  saveTerms(context, isDispatched = false) {
    let options = [];
    // change from year unit to month unit
    for (let i = 1; i <= 84; i++) {
      options.push({
        label: i + (i > 1 ? " months" : " month"),
        value: i
      });
    }
    context.commit("setTerms", options);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
